<template>
  <div>


    <div class="price " :class="[
      { 'animate__animated animate__zoomOutLeft': isDeleting },
      { 'price--deleting': wasDeleted },

    ]">
      <div class="icon icon__chevron-down-green"
        v-if="price && price.price_companies && price.price_companies.length > 0 && $checkRolePermission('company_price_access')"
        :class="{ 'icon__chevron-down-green--active': expanded }" @click="expanded = !expanded"></div>
      <div class="column column--branch">
        <span>{{ price.branch_category?.[`long_${language}`] }}</span>
      </div>
      <div class="column column--agent">
        <span @click="showPopupEditer = true">
          <transition name="fade">
            <PopupEditer v-if="showPopupEditer" :selected="price.agent_provision * 100"
              @togglePopup="showPopupEditer = $event" @submit="changeAgentProvision($event)" />
          </transition>
          {{ (agentProvision * 100).toFixed(2) }}%
        </span>
      </div>
      <div class="column column--company">
        <span>{{ (price.company_provision * 100).toFixed(2) }}%</span>
      </div>
      <div class="icon icon__add" @click="addPriceCompany()" v-if="$checkRolePermission('company_price_access')">
      </div>
      <div class="icon icon__delete" @click="deletePrice()"></div>


    </div>
    <div class="company__prices__table" v-if="expanded">
      <PriceCompanyRow v-for="priceCompany in price.price_companies || []" :key="priceCompany.id" :priceCompany="priceCompany"
        :selectSale="selectSale" :teamId="teamId" :salesCategoryId="price.sales_category_id" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import PopupEditer from "@/partials/PopupEditer";
import PriceCompanyRow from "@/components/PriceCategories/PriceCompanyRow";

defineOptions({
  name: "PriceRow"
});

const props = defineProps({
  price: {
    required: true,
    type: Object,
  },
  selectSale: {
    required: true,
    type: Function,
  },
  teamId: {
    required: true,
    type: Number,
  },
});

const store = useStore();

// State
const isDeleting = ref(false);
const wasDeleted = ref(false);
const expanded = ref(false);
const showPopupEditer = ref(false);
const agentProvision = ref("");
const agentProvisionCopy = ref("");

// Computed
const language = computed(() => store.getters.language);
//const priceCompaniesLength = computed(() => props.price.price_companies.length);

// Methods
const deletePrice = async () => {
  isDeleting.value = true;
  await store.dispatch("deleteSaleCategoryPrice", props.price.id);
  wasDeleted.value = true;

  setTimeout(async () => {
    await store.dispatch("getSaleCategories");
    props.selectSale(props.price.sales_category_id);
  }, 300);
};

const changeAgentProvision = async (provision) => {
  if (
    provision <= 100 &&
    provision >= 0 &&
    provision !== agentProvisionCopy.value
  ) {
    agentProvision.value = provision / 100;
    await store.dispatch("updateSaleCategoryPrice", {
      saleCategoryPriceId: props.price.id,
      provision,
    });

    // Check permission logic
    if (props.teamId && store.getters.checkRolePermission("team_access")) {
      await store.dispatch("getSaleCategoriesByTeam", props.teamId);
    } else {
      await store.dispatch("getSaleCategories");
    }
    props.selectSale(props.price.sales_category_id);
  }
};

const addPriceCompany = () => {
  store.commit("setSaleCategoryPriceId", props.price.id);
  store.commit("setShowAddSaleCategoryCompanyModal", true);
};

// Lifecycle
onMounted(() => {
  agentProvision.value = props.price.agent_provision;
  agentProvisionCopy.value = props.price.agent_provision;
});
</script>

<style lang="scss" scoped>
span {
  color: var(--text-9);
}

.price {
  border-bottom: 1px solid var(--border-15);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 35px;
  padding-left: 20px;
  position: relative;
  max-height: 47px;
  transition: all 0.3s ease;

  &--deleting {
    padding: 0px 20px;
    max-height: 0px;
    overflow: hidden;
    border: 0;
  }

  .icon__chevron-down-green {
    left: 5px;

  }

  &--expanded {
    max-height: 500px;

  }

  .icon {
    position: absolute;
    right: 25px;
  }

  .icon__add {
    right: 60px;
  }


}

.company__prices__table {
  width: 100%;

}
</style>
